import { useRouter } from 'next/router';
import confirm from 'src/components/saleModal/method';
export function useGoLink() {
  const router = useRouter();
  const goLink = (href: string) => {
    if (typeof window.__BEFORE_ROUTER === 'function') {
      window
        .__BEFORE_ROUTER()
        .then(() => {
          router.push(href);
          setBeforeRoute(false);
        })
        .catch(() => {
          console.log('用户取消跳转');
        });
    } else {
      router.push(href);
    }
  };
  return goLink;
}

export const setBeforeRoute = (b: boolean) => {
  if (b) {
    window.__BEFORE_ROUTER = () =>
      confirm({
        title: '信息没保存',
        content: '信息还没保存，确认离开吗？',
        okTxt: '确认',
        cancelTxt: '取消',
      });
  } else {
    window.__BEFORE_ROUTER = null;
  }
};

export const openURL = (url: string) => {
  const link = document.createElement('a');
  link.target = '_blank';
  link.href = url;
  link.click();
};
